<script>
  import { navigate } from "svelte-routing";
  const tabata = () => {
    navigate("/tabata");
  };
  const emom = () => {
    navigate("/emom");
  };
  const wodtime = () => {
    navigate("/wodtime");
  };
</script>

<div class="margem">
    <div class="texto">
      <div>TIMERS</div>
      <br>
      <button class="texto" on:click={tabata}>Tabata</button>
      <br><br>
      <button class="texto" on:click={emom}>EMOM</button>
      <br><br>
      <button class="texto" on:click={wodtime}>WOD Time</button>
    </div>
</div>

<style>
  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    background-color: #1976d2;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 100%
  }

  .texto {
     font-size: 25px;
     font-family:verdana;
     font-weight: bold;
     text-align: center;
  }

</style>
